module.exports = __webpack_public_path__ + "img/success.97777803.png";